import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IkitState } from "./kit.types";
import axiosInstance from "config/axios";

const initialState: IkitState = {
  kit: [],
  singlekit: {
    _id: "",
    petId: "",
    user: {},
    code: 0,
    price: 0,
    status: "",
  },
  kitError: {},
  iskitActivityInProcess: false,
  kitSuccessMesssage: "",
  fileMessage: "",
  totalRecords: 0,
  totalPages: 0,
};

export const getKits = createAsyncThunk("getkits/kit", async (page: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().get(`/kit/get-kits?page=${page}`);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const sampleReceived = createAsyncThunk("sampleRecieved/kit", async (kit: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().post(`/kit/kit-sample-recieved`, kit);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const activateKit = createAsyncThunk(
  "activateKit/kit",
  async (
    { kitId, purchaseDetails }: { kitId: any; purchaseDetails: Record<string, { checked: boolean; reason: string }> },
    { rejectWithValue }
  ) => {
    try {
      // Ensure the data structure remains an object
      const filteredPurchaseDetails = Object.keys(purchaseDetails).reduce(
        (acc, key) => ({
          ...acc,
          [key]: purchaseDetails[key],
        }),
        {}
      );

      const { data } = await axiosInstance().post(`/kit/check-kit-code/${kitId}`, {
        purchaseDetails: filteredPurchaseDetails,
      });

      return data;
    } catch (error: any) {
      return rejectWithValue(error.response);
    }
  }
);

export const createKit = createAsyncThunk("createKit/kit", async (kitCode: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().post(`/kit/generate-kit`, kitCode);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const createKitFile = createAsyncThunk("createKitFile/kit", async (kits: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().post(`/kit/generate-kit`, kits);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const updateKit = createAsyncThunk("updateKit/kit", async (kit: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().put(`/kit/update-kit`, kit);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const getSinglekit = createAsyncThunk("getSinglekit/kit", async (kitID: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().get(`/kit/get-kit/${kitID}`);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

const kitSlice = createSlice({
  name: "kitSlice",
  initialState: { ...initialState, name: "kitInitialState" },
  reducers: {
    errorClean: (state) => {
      state.kitError = {
        code: null,
        message: "",
        error: "",
      };
    },
    messageClean: (state) => {
      state.kitSuccessMesssage = "";
    },
  },
  extraReducers: (builder) => {
    // get all kits cases
    builder.addCase(getKits.pending, (state, action: any) => {
      state.iskitActivityInProcess = true;
    });

    builder.addCase(getKits.rejected, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getKits.fulfilled, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitSuccessMesssage = action.payload.message;
      state.totalRecords = action.payload.totalKits;
      state.totalPages = action.payload.totalPages;
      state.kit = action.payload.kit;
    });

    // sample recieved cases
    builder.addCase(sampleReceived.pending, (state, action: any) => {
      state.iskitActivityInProcess = true;
    });

    builder.addCase(sampleReceived.rejected, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(sampleReceived.fulfilled, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitSuccessMesssage = action.payload.message;
      state.totalRecords = action.payload.totalKits;
      state.totalPages = action.payload.totalPages;
      state.kit = action.payload.kit;
    });

    // activate kit cases
    builder.addCase(activateKit.pending, (state, action: any) => {
      state.iskitActivityInProcess = true;
    });

    builder.addCase(activateKit.rejected, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(activateKit.fulfilled, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitSuccessMesssage = action.payload.message;

      //   state.kit = action.payload.kits;
    });

    // create kit cases
    builder.addCase(createKit.pending, (state, action: any) => {
      state.addKit = true;
    });

    builder.addCase(createKit.rejected, (state, action: any) => {
      state.addKit = false;
      state.kitError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
      state.kitSuccessMesssage = "";
    });

    builder.addCase(createKit.fulfilled, (state, action: any) => {
      state.addKit = false;
      state.kitSuccessMesssage = action.payload.message;
      state.kitError = {
        code: "",
        message: "",
      };

      //   state.kit = action.payload.kits;
    });

    builder.addCase(createKitFile.pending, (state, action: any) => {
      state.addKit = true;
    });

    builder.addCase(createKitFile.rejected, (state, action: any) => {
      state.addKit = false;
      state.kitError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
      state.kitSuccessMesssage = "";
    });

    builder.addCase(createKitFile.fulfilled, (state, action: any) => {
      state.addKit = false;
      state.fileMessage = action.payload.message;
      state.kitError = {
        code: "",
        message: "",
      };

      //   state.kit = action.payload.kits;
    });

    // update kit cases
    builder.addCase(updateKit.pending, (state, action: any) => {
      state.iskitActivityInProcess = true;
    });

    builder.addCase(updateKit.rejected, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(updateKit.fulfilled, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitSuccessMesssage = action.payload.message;

      //   state.kit = action.payload.kits;
    });

    // get single kit by kitID cases
    builder.addCase(getSinglekit.pending, (state, action: any) => {
      state.iskitActivityInProcess = true;
    });

    builder.addCase(getSinglekit.rejected, (state, action: any) => {
      state.iskitActivityInProcess = false;
      state.kitError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getSinglekit.fulfilled, (state, action: any) => {
      state.iskitActivityInProcess = false;
      // state.kitSuccessMesssage = action.payload.message;

      state.singlekit = action.payload.kit;
    });
  },
});
export const { errorClean, messageClean } = kitSlice.actions;

export default kitSlice.reducer;
